import 'bootstrap';
import ReactDOM from 'react-dom';
import App from './App';
import authentication from "shared/authentication";
import axios, {AxiosPost} from "shared/libs/axios";

const start = () => {
  ReactDOM.render(<App/>, document.getElementById('root'));
};

axios({
  url: `${process.env.REACT_APP_DOMAIN_MEMBER_BNET}/member/api/login/refresh-token/member`,
  method: 'post',
}).then((res: any) => {
  authentication.set(res.data);
  start();
})
  .catch(start);
// AxiosPost("/member/api/login/refresh-token/member",
//   undefined,
//   {
//     baseURL: `${process.env.REACT_APP_DOMAIN_MEMBER_BNET}`
//   }).then((data: any) => {
//   authentication.set(data);
//   start();
// }).catch(start);



